import { render, staticRenderFns } from "./Particular.vue?vue&type=template&id=fba5315a&scoped=true&"
import script from "./Particular.vue?vue&type=script&lang=js&"
export * from "./Particular.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fba5315a",
  null
  
)

export default component.exports